import useReveal from "@/hooks/useReveal";
import { Check, X } from "lucide-react";

const fits = [
  "Creators with an engaged audience but no recurring product revenue.",
  "Personal brands ready to launch their first paid product or membership.",
  "Founders who need an execution partner, not another consultant deck.",
];

const notFits = [
  "Anyone looking for vanity metrics or follower-chasing.",
  "Brands without an existing audience or distribution.",
  "Stakeholders who need weekly status meetings and slide reviews.",
];

export default function WhoThisIsFor() {
  const ref = useReveal();
  return (
    <section
      id="who-this-is-for"
      data-testid="who-section"
      ref={ref}
      className="reveal relative px-6 md:px-12 py-28 md:py-40 bg-[#0A0A0A] border-t border-[#2E2A28]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-5">
          <div className="overline section-mark mb-6">Who This Is For</div>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light leading-[1.05] tracking-tight text-[#F2E7DF]">
            A short list. <br />
            <span className="italic text-[#A19D9B]">By design.</span>
          </h2>
          <div
            className="mt-10 hidden md:block aspect-[4/5] w-full bg-cover bg-center border border-[#2E2A28]"
            style={{
              backgroundImage:
                "url(https://images.pexels.com/photos/12655344/pexels-photo-12655344.jpeg)",
            }}
            aria-hidden="true"
          />
        </div>

        <div className="col-span-12 md:col-span-6 md:col-start-7 space-y-12">
          <div>
            <div className="font-mono-detail text-[0.7rem] tracking-[0.28em] uppercase text-[#E5C16C] mb-6">
              + Right Fit
            </div>
            <ul className="space-y-5">
              {fits.map((f, i) => (
                <li
                  key={i}
                  data-testid={`fit-yes-${i}`}
                  className="flex gap-4 border-b border-[#2E2A28] pb-5 last:border-b-0"
                >
                  <Check size={20} strokeWidth={1.5} className="text-[#E5C16C] shrink-0 mt-1" />
                  <p className="text-lg text-[#F2E7DF] font-light leading-relaxed">{f}</p>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono-detail text-[0.7rem] tracking-[0.28em] uppercase text-[#A19D9B] mb-6">
              — Not For You If
            </div>
            <ul className="space-y-5">
              {notFits.map((f, i) => (
                <li
                  key={i}
                  data-testid={`fit-no-${i}`}
                  className="flex gap-4 border-b border-[#2E2A28] pb-5 last:border-b-0"
                >
                  <X size={20} strokeWidth={1.5} className="text-[#A19D9B] shrink-0 mt-1" />
                  <p className="text-lg text-[#A19D9B] font-light leading-relaxed">{f}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
